var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilterIcon24(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "filter__Action Type=Filter, State=Enabled, Size=24",
    className: "filter__Action filter__Type=Filter, filter__State=Enabled, filter__Size=24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "filter__Vector",
    fill: "currentColor",
    d: "M10.859 18.847h2.282c.628 0 1.141-.514 1.141-1.141 0-.628-.513-1.142-1.14-1.142h-2.283c-.628 0-1.141.514-1.141 1.142 0 .627.513 1.14 1.14 1.14ZM1.729 6.294c0 .627.514 1.14 1.141 1.14h18.26c.627 0 1.14-.513 1.14-1.14 0-.628-.513-1.142-1.14-1.142H2.87c-.627 0-1.14.514-1.14 1.142Zm4.565 6.847h11.412c.628 0 1.141-.514 1.141-1.141 0-.628-.513-1.142-1.141-1.142H6.294c-.628 0-1.141.514-1.141 1.142 0 .627.513 1.14 1.141 1.14Z",
    className: "filter__Vector"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon24);
export default __webpack_public_path__ + "static/media/filter_icon_24.f382c1a47360931cdadb2af834765355.svg";
export { ForwardRef as ReactComponent };